<template>
  <v-data-table
    v-model="selectedItems"
    :headers="shareeCamerasHeaders"
    :items="shareRequests"
    dense
    :show-select="canDelete || canResend"
    disable-pagination
    hide-default-footer
  >
    <template #top>
      <div class="e-flex e-justify-end e-gap-2 pa-2">
        <v-btn
          v-if="canDelete"
          small
          color="error"
          :disabled="btnDisabled"
          @click="() => $emit('delete-share-requests', selectedItems)"
        >
          Delete
        </v-btn>
        <v-btn
          v-if="canResend"
          small
          color="primary"
          :disabled="btnDisabled"
          @click="() => $emit('resend-share-requests', selectedItems)"
        >
          Resend
          <v-icon right> far fa-paper-plane </v-icon>
        </v-btn>
      </div>
    </template>
    <template #item.camera="{ item }">
      <span
        class="cursor-pointer primary--text"
        @click="cameraDialogStore.openDialog({ camera: item.cameraExid })"
      >
        {{ item.camera }}
      </span>
    </template>
    <template #item.createdAt="{ item }">
      {{ formatDate(item.createdAt) }}
    </template>

    <template #item.message="{ item }">
      <EReadMore :content="item.message" :max-length="60" />
    </template>
  </v-data-table>
</template>

<script>
import { shareeCamerasHeaders } from "@/components/shareRequests/pendingShareRequestsHeaders"

import { mapStores } from "pinia"
import { useCameraDialogStore } from "@/stores/cameraDialog"

export default {
  name: "ShareeRequestsTable",
  props: {
    shareRequests: {
      type: Array,
      default: () => [],
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canResend: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      shareeCamerasHeaders,
      selectedItems: [],
    }
  },
  computed: {
    ...mapStores(useCameraDialogStore),
    btnDisabled() {
      return !this.selectedItems?.length
    },
  },
}
</script>
